export const apiConfig = {
	baseURL: 'https://www.whereismypackage.app'
};
